import { Injectable } from '@angular/core';
import {
  FileUploadContext,
  FileUploadControlComponentDelegate,
} from '@fry/components/common/file-upload-control';


@Injectable()
export class UserFileUploadDelegate implements FileUploadControlComponentDelegate {

  private context: FileUploadContext | null = null;

  constructor(
  ) { }

  setContext(context: FileUploadContext) {
    this.context = context;
  }

  getContext(): FileUploadContext | null {
    return this.context;
  }
}
